import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CommonFieldLabel, CommonFieldName, SelectItems } from "@app/shared/constants";
import { BooleanYesNoTranslate } from "@app/shared/pipes/boolean-yes-no-translate";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { YearMonth } from "@app/shared/pipes/year-month";
import { SubRegion } from "@app/shared/classes/subRegion";
import { DynamicTranslate } from "@app/shared/pipes/dynamic-translate";
import { GenerateKpiDropDownItems, Kpi } from "@app/shared/classes/kpi";

export enum ITToolUsageFieldName {
  driverName = "driverName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  country = "country",
  kpiName = "kpiName",
  kpi_Translation_Id = "kpi_Translation_Id",
  kpiDate = "kpiDate",
  compliance = "compliance",
  occurrenceToTarget = "occurrenceToTarget",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  apexId = "apexId",
  fullName = "fullName"
};

enum FieldLabel {
  DRIVER_NAME = "ml_143908",
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  KPI_NAME = "ml_143913",
  YEAR_AND_MONTH = "ml_143914",
  COMPLANCE = "ml_143915",
  OCCURRENCETOTARGET = "ml_144166",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  DRIVER_APEX_ID = "ml_143930",
}

const ITToolUsageSearchByList: SearchByItem[] = [
  { searchBy: ITToolUsageFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: ITToolUsageFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: ITToolUsageFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: ITToolUsageFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: ITToolUsageFieldName.kpiName, searchByLabel: FieldLabel.KPI_NAME, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: ITToolUsageFieldName.kpiDate, searchByLabel: FieldLabel.YEAR_AND_MONTH, searchByType: smartSearchType.singleSelect,
    searchDropDownValue: [{ value: 1, label: "ml_143943" }, { value: 3, label: "ml_143944" }, { value: 6, label: "ml_143945" }, { value: 12, label: "ml_143946" }]
  },
  {
    searchBy: ITToolUsageFieldName.compliance, searchByLabel: FieldLabel.COMPLANCE, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: SelectItems.complianceSelectItems
  },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_NAME,
    name: ITToolUsageFieldName.driverName,
    sort: true,
    sortFieldName: ITToolUsageFieldName.fullName
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: ITToolUsageFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: ITToolUsageFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: ITToolUsageFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: ITToolUsageFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.KPI_NAME,
    name: ITToolUsageFieldName.kpi_Translation_Id,
    sort: true,
    pipe: DynamicTranslate
  },
  {
    text: FieldLabel.YEAR_AND_MONTH,
    name: ITToolUsageFieldName.kpiDate,
    sort: true,
    pipe: YearMonth
  },
  {
    text: FieldLabel.COMPLANCE,
    name: ITToolUsageFieldName.compliance,
    sort: true,
    pipe: BooleanYesNoTranslate
  },
  {
    text: FieldLabel.OCCURRENCETOTARGET,
    name: ITToolUsageFieldName.occurrenceToTarget,
  },
  {
    text: FieldLabel.CREATED_BY,
    name: ITToolUsageFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: ITToolUsageFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: ITToolUsageFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: ITToolUsageFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
];

export const GetITToolUsageSearchByList = ([terminals, subRegions, kpis, userCountry]: [DropDownItem[], SubRegion[], Kpi[], string]) => {
  var result = ITToolUsageSearchByList.slice();
  result[2].searchDropDownValue = terminals;
  result[3].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  result[4].searchDropDownValue = GenerateKpiDropDownItems(
    kpis.filter(kpi => kpi && kpi.kpiConfigurations && kpi.kpiConfigurations.filter(config => config && config.country === userCountry).length > 0));
  return result;
}
